import { render, staticRenderFns } from "./CategoryBarChart.vue?vue&type=template&id=2c1c027a&"
import script from "./CategoryBarChart.vue?vue&type=script&lang=js&"
export * from "./CategoryBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports